export default __webpack_public_path__ + "static/media/intia.abee6937.jpg";